
import {
  useGetThemesQuery,
  useCreateOrUpdateThemeMutation,
  useDeleteThemeMutation,
} from '../../baseApi';

/**
 * Hook to fetch paginated themes.
 * Usage: const { data, isLoading, refetch } = useThemeList({ pageNumber:1, pageSize:10, columnName: 'ReportTitle', value: 'ABC' });
 */
export const useThemeList = (pageNumber = 1, pageSize = 10, filters = {}) => {
  // The controller expects pageNumber/pageSize in the request body
  const payload = { pageNumber, pageSize, ...filters };
  return useGetThemesQuery(payload);
};

/**
 * Hook bundling theme mutations, including file upload.
 * createOrUpdateTheme expects a FormData instance.
 */
export const useThemeOperations = () => {
  const [createOrUpdateTheme, { isLoading: saving, data: saveResult, error: saveError }] = useCreateOrUpdateThemeMutation();
  const [deleteTheme, { isLoading: deleting, data: deleteResult, error: deleteError }] = useDeleteThemeMutation();

  return {
    createOrUpdateTheme, // call with FormData
    deleteTheme,         // call with id
    isProcessing: saving || deleting,
    results: { saveResult, deleteResult },
    errors: { saveError, deleteError },
  };
};
